import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 20 20"

const ShippingIcon = createSvgIcon(
  <>
    <path
      xmlns='http://www.w3.org/2000/svg'
      className='st0'
      d='M5,16c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.5-0.7-1.1-0.7-1.8H1V5c0-0.4,0.1-0.8,0.4-1.1c0.3-0.3,0.6-0.4,1.1-0.4H14  v3h2.5L19,10v3.5h-1.5c0,0.7-0.2,1.3-0.7,1.8C16.3,15.8,15.7,16,15,16c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.5-0.7-1.1-0.7-1.8h-5  c0,0.7-0.2,1.3-0.7,1.8C6.3,15.8,5.7,16,5,16z M5,14.5c0.3,0,0.5-0.1,0.7-0.3C5.9,14,6,13.8,6,13.5c0-0.3-0.1-0.5-0.3-0.7  c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3C4.1,13,4,13.2,4,13.5c0,0.3,0.1,0.5,0.3,0.7C4.5,14.4,4.7,14.5,5,14.5z M2.5,12H3  c0.2-0.3,0.5-0.6,0.9-0.7C4.2,11.1,4.6,11,5,11c0.4,0,0.8,0.1,1.1,0.3C6.5,11.4,6.8,11.7,7,12h5.5V5h-10V12z M15,14.5  c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3  C14.1,13,14,13.2,14,13.5c0,0.3,0.1,0.5,0.3,0.7C14.5,14.4,14.7,14.5,15,14.5z M14,10.5l3.5,0L15.7,8H14V10.5z'
    />
  </>,
  'ShippingIcon'
)

export default ShippingIcon
